import React,{useState} from 'react'
import { images } from '../../utils/customFn'
import './quickpay.scss'
import { Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { QuestionIcon } from '../../icon/icons'
import { QuickpayModal } from '../../components'

const QuickPay = () => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (
        <div className='quickpay'>
            <div className='header'>
                <Link to="/">
                    <img src={images['logo.avif']} alt='logo' className='logo' />
                </Link>
            </div>
            <Container>
                <div className='content'>
                    <div className='main_heading'>
                        <h2>Quick pay</h2>
                        <p>Pay your bill quickly without needing to register.</p>
                    </div>
                    <div className='pay-wrapper'>
                        <div className='pay_heading'>
                            <h2>Pay now</h2>
                        </div>
                        <div className='industryDropdownSelector'>
                            <div className='Zip-code policy-input'>
                                <input type="text" placeholder="Account or policy number" />
                                <button type='button' className='icon' onClick={handleShow}>
                                    <QuestionIcon />
                                </button>
                            </div>
                            <div className='Zip-code'>
                                <input type="text" placeholder="Enter your ZIP code" maxlength="5" />
                            </div>
                            <button type="submit" className="findAgentButton">Submit</button>
                        </div>
                    </div>
                </div>
            </Container>
            <div className='footer_content'>
                <div className='links'>
                    <Link to=""> Terms & Conditions </Link>
                    | <Link to="">Privacy</Link>
                </div>
                <div className='contact'>
                    <span>Contact Us | 1-800-473-6879</span>
                </div>
            </div>
            <QuickpayModal handleClose={handleClose} show={show}/>
        </div>
    )
}

export default QuickPay
